<div style="width: 500px; height: 600px;" data-cy="mti-priorexam-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="mti-priorexam-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="mti-priorexam-header">
      <div class="section-header-title" data-cy="mti-priorexam-title">
        Select teeth
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="mti-priorexam-content">
      <div style="height: 100%; width: 100%; max-height: 100%; max-width: 100%;" data-cy="mti-priorexam-table-container">
        <tdo-table (rowSelected)="onRowSelected($event)" [isMultiSelection]="true" [dataSource]="dataSource" [isSearchable]="false" data-cy="mti-priorexam-table">
          <tdo-table-column [rowTemplate]="name" displayName="Examination" propertyName="Description" targetObjectName="exam"  [isSortable]="true" data-cy="mti-priorexam-column-description">
            <ng-template #name let-row>
              {{row.Description}}
            </ng-template>
          </tdo-table-column>
          <tdo-table-column [rowTemplate]="date" displayName="Date" targetObjectName="exam" propertyName="xauditCreatedOn" [isSortable]="true" data-cy="mti-priorexam-column-date">
            <ng-template #date let-row>
              {{getDate(row.xauditCreatedOn)}}
            </ng-template>
          </tdo-table-column>
          <tdo-table-column [rowTemplate]="tooth" displayName="Tooth" targetObjectName="tooth" propertyName="ToothId" [isSortable]="true" data-cy="mti-priorexam-column-tooth">
            <ng-template #tooth let-row>
              {{getTooth(row.ToothId)}}
            </ng-template>
          </tdo-table-column>
          <tdo-table-column [rowTemplate]="checked" displayName="" propertyName="isSelected" data-cy="mti-priorexam-column-selected">
            <ng-template #checked let-row>
              <div class="ui-dark-background" data-cy="mti-priorexam-checkbox-container">
                <mat-checkbox style="pointer-events: none; position: relative; top: 4px;" [checked]="row.model.isChecked" data-cy="mti-priorexam-checkbox"></mat-checkbox>
              </div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="mti-priorexam-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="mti-priorexam-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="mti-priorexam-ok-button">Ok</button>
    </div>
  </div>
</div>
